__turbopack_context__.v({
  "form": "trade-in-form-module-scss-module__iIoHma__form",
  "formTitle": "trade-in-form-module-scss-module__iIoHma__formTitle",
  "form__agreement": "trade-in-form-module-scss-module__iIoHma__form__agreement",
  "form__error": "trade-in-form-module-scss-module__iIoHma__form__error",
  "form__icon": "trade-in-form-module-scss-module__iIoHma__form__icon",
  "form__item": "trade-in-form-module-scss-module__iIoHma__form__item",
  "form__item__item_phone": "trade-in-form-module-scss-module__iIoHma__form__item__item_phone",
  "form__item_delivery": "trade-in-form-module-scss-module__iIoHma__form__item_delivery",
  "form__item_link": "trade-in-form-module-scss-module__iIoHma__form__item_link",
  "form__item_payment": "trade-in-form-module-scss-module__iIoHma__form__item_payment",
  "form__item_phone": "trade-in-form-module-scss-module__iIoHma__form__item_phone",
  "form__submit": "trade-in-form-module-scss-module__iIoHma__form__submit",
  "form__success": "trade-in-form-module-scss-module__iIoHma__form__success",
  "form__text": "trade-in-form-module-scss-module__iIoHma__form__text",
  "link": "trade-in-form-module-scss-module__iIoHma__link",
  "mainPrice": "trade-in-form-module-scss-module__iIoHma__mainPrice",
  "modal": "trade-in-form-module-scss-module__iIoHma__modal",
  "oldPrice": "trade-in-form-module-scss-module__iIoHma__oldPrice",
  "priceBreakdown": "trade-in-form-module-scss-module__iIoHma__priceBreakdown",
  "priceBreakdown__info": "trade-in-form-module-scss-module__iIoHma__priceBreakdown__info",
  "priceBreakdown__label": "trade-in-form-module-scss-module__iIoHma__priceBreakdown__label",
  "priceBreakdown__leader": "trade-in-form-module-scss-module__iIoHma__priceBreakdown__leader",
  "priceBreakdown__row": "trade-in-form-module-scss-module__iIoHma__priceBreakdown__row",
  "priceBreakdown__value": "trade-in-form-module-scss-module__iIoHma__priceBreakdown__value",
  "priceBreakdown__value_benefit": "trade-in-form-module-scss-module__iIoHma__priceBreakdown__value_benefit",
  "priceBreakdown__value_old": "trade-in-form-module-scss-module__iIoHma__priceBreakdown__value_old",
  "priceWrap": "trade-in-form-module-scss-module__iIoHma__priceWrap",
  "product": "trade-in-form-module-scss-module__iIoHma__product",
  "product__content": "trade-in-form-module-scss-module__iIoHma__product__content",
  "product__image": "trade-in-form-module-scss-module__iIoHma__product__image",
  "product__price": "trade-in-form-module-scss-module__iIoHma__product__price",
  "product__title": "trade-in-form-module-scss-module__iIoHma__product__title",
  "subtitle": "trade-in-form-module-scss-module__iIoHma__subtitle",
  "text": "trade-in-form-module-scss-module__iIoHma__text",
  "title": "trade-in-form-module-scss-module__iIoHma__title",
  "tooltip": "trade-in-form-module-scss-module__iIoHma__tooltip",
  "tradeInCalculator": "trade-in-form-module-scss-module__iIoHma__tradeInCalculator",
  "tradeInCalculator__categories": "trade-in-form-module-scss-module__iIoHma__tradeInCalculator__categories",
  "tradeInCalculator__reset": "trade-in-form-module-scss-module__iIoHma__tradeInCalculator__reset",
  "tradeInCalculator__segment": "trade-in-form-module-scss-module__iIoHma__tradeInCalculator__segment",
  "tradeInCalculator__select": "trade-in-form-module-scss-module__iIoHma__tradeInCalculator__select",
  "tradeInCalculator__wrapper": "trade-in-form-module-scss-module__iIoHma__tradeInCalculator__wrapper",
  "tradeInPrice": "trade-in-form-module-scss-module__iIoHma__tradeInPrice",
  "tradeInPriceBlock": "trade-in-form-module-scss-module__iIoHma__tradeInPriceBlock",
  "tradeInSelectors": "trade-in-form-module-scss-module__iIoHma__tradeInSelectors",
  "tradeInTitle": "trade-in-form-module-scss-module__iIoHma__tradeInTitle",
});
